import { render } from "./answer-reply-form.html?vue&type=template&id=4378e96a"
import script from "./AnswerReplyForm.vue?vue&type=script&lang=ts"
export * from "./AnswerReplyForm.vue?vue&type=script&lang=ts"

import "./answer-reply-form.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script